import {
  TClaimedPromoPrizeReward,
  TGetClaimedPrizeWinsResponse,
  TUnclaimedPromoPrizeReward,
} from '@daymade/api-contracts';
import { TClaimedPrizeWin, TUnclaimedPrizeWin } from 'stores/UserStore';

export type TPrizeDisplayItem =
  | TUnclaimedPrizeWin
  | TClaimedPrizeWin
  | TUnclaimedPromoPrizeReward
  | TClaimedPromoPrizeReward;

export const isLoadedPrizeWins = <T>(
  wins: T[] | 'LOADING' | 'ERROR',
): wins is T[] => Array.isArray(wins);

export const isClaimedPrizeWin = (
  prize: TPrizeDisplayItem,
): prize is TGetClaimedPrizeWinsResponse[number] =>
  'chosenAt' in prize && 'isChosenByPlayer' in prize;

export const isUnclaimedPromoPrizeReward = (
  prize: TPrizeDisplayItem,
): prize is TUnclaimedPromoPrizeReward =>
  'code' in prize && !('chosenPrizeProducts' in prize);

export const isClaimedPromoPrizeReward = (
  prize: TPrizeDisplayItem,
): prize is TClaimedPromoPrizeReward =>
  'code' in prize && 'chosenPrizeProducts' in prize;
